import React from 'react';
import List from "@material-ui/core/List";
import {Container} from "@material-ui/core";
import {blueGrey} from "@material-ui/core/colors";
import ListItem from "@material-ui/core/ListItem";
import Accordion from '@material-ui/core/Accordion';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {MateriasSource} from "../Source/MateriasSource";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {UVT_MATERIAS} from "../Source/Materias";
import {USER_MAJOR} from "../App";
import {useAppContext} from "../libs/contextLib";

const useStyles = makeStyles((theme) => ({
    root: {
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: '500',
    },
    semestre: {
        padding: '25px 50px'
    },
    titles: {
        paddingLeft: '50px'
    },
    titleWithBackgroundImage: {
        background: `url("https://uvt-public-assets.s3-us-west-1.amazonaws.com/Compass.jpg")`,
        backgroundSize: '100%',
        opacity: '.85',
        backgroundRepeat: 'no-repeat',
        paddingLeft: '70px',
        marginBottom: '25px',
        color: 'white',
        height: '20rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    }
}));

export default function Materias(props) {
    const {userEmail} = useAppContext();
    const major = USER_MAJOR[userEmail];
    const classes = useStyles();
    return (
        <Container className={classes.root}>
            <div className={classes.titleWithBackgroundImage}>
                <Typography variant="h2" gutterBottom>
                    Plan de Estudios
                </Typography>
                <Typography variant="h3" gutterBottom>
                    Materias y objetivos para la carrera de Licenciatura en Administración de Empresas
                </Typography>
            </div>
            {Object.keys(UVT_MATERIAS[major]).map(o => {
                return (
                    <div className={classes.semestre}>
                        <Typography variant='h4' style={{paddingBottom: '10px'}}>
                            {UVT_MATERIAS[major][o].description}
                        </Typography>
                        {UVT_MATERIAS[major][o].materias.map(o => {
                            return (
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id={o.topicId}
                                    >
                                        <Typography
                                            className={classes.heading}>{`${o.topicId}: ${o.name}`}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <Typography variant="h6">
                                                Fines del Aprendizaje o Formación
                                            </Typography>
                                            <Typography variant="body1">
                                                {o.objective}
                                            </Typography>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            );
                        })}
                    </div>
                );
            })}
        </Container>
    );
}

